import { render, staticRenderFns } from "./CommunicationMessages.vue?vue&type=template&id=3938b04a&"
import script from "./CommunicationMessages.vue?vue&type=script&lang=ts&"
export * from "./CommunicationMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports